if (!customElements.get('gallery-hotspot-block')) {
  class GalleryHotspotBlock extends HTMLElement {
    connectedCallback() {
      this._mq = window.matchMedia('(hover: none), (pointer: coarse)');
      if (this._mq.matches) this._initMobile();
      this._mq.addEventListener('change', (e) => {
        if (e.matches) this._initMobile();
      });
    }

    _initMobile() {
      this.querySelectorAll('.gallery-hotspots__pin').forEach((pin) => {
        pin.addEventListener('click', () => {
          const tooltip = pin.closest('.gallery-hotspots__pin-wrapper').querySelector('.gallery-hotspots__tooltip');
          GalleryHotspotBlock._openPopup(tooltip.innerHTML);
        });
      });
    }

    static _openPopup(content) {
      let popup = document.getElementById('gallery-hotspots-popup');

      if (!popup) {
        popup = document.createElement('div');
        popup.id = 'gallery-hotspots-popup';
        popup.className = 'gallery-hotspots-popup';
        popup.setAttribute('role', 'dialog');
        popup.setAttribute('aria-modal', 'true');
        popup.innerHTML = `
          <div class="gallery-hotspots-popup__backdrop"></div>
          <div class="gallery-hotspots-popup__sheet">
            <button class="gallery-hotspots-popup__close" type="button" aria-label="Close">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <line x1="16" y1="4" x2="4" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <div class="gallery-hotspots-popup__body"></div>
          </div>
        `;
        document.body.appendChild(popup);

        popup.querySelector('.gallery-hotspots-popup__backdrop').addEventListener('click', GalleryHotspotBlock._closePopup);
        popup.querySelector('.gallery-hotspots-popup__close').addEventListener('click', GalleryHotspotBlock._closePopup);
      }

      popup.querySelector('.gallery-hotspots-popup__body').innerHTML = content;
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    static _closePopup() {
      const popup = document.getElementById('gallery-hotspots-popup');
      if (!popup) return;
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  customElements.define('gallery-hotspot-block', GalleryHotspotBlock);
}
